import { render, staticRenderFns } from "./ReplaceByDelete.vue?vue&type=template&id=4ea56d47&scoped=true"
import script from "./ReplaceByDelete.vue?vue&type=script&lang=js"
export * from "./ReplaceByDelete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ea56d47",
  null
  
)

export default component.exports